interface ContainerProps {
    text: string;
}

export const SomethingWentWrong: React.FC<ContainerProps> = ({ text }) => {
    return <div>{text}</div>;
};
